import React, { useState } from "react";
import Select from "react-select";
import * as RelationUtils from "utils/relation";
import { customMapper, selectOnChangeWrapper, mapToSelectOption, mapToSelectOptions } from "utils/select";
import { getAccount } from "containers/Accounts/reducer";
import { getDataset, getDatasetsArr } from "containers/Home/reducer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import styles from "components/Tiles/Sense/style.module.css";
import { useSelector } from "@/types/store";
const DATASET_MAPPER = customMapper((d) => `(${d.id}) ${d.name}`);
function filterUndefinedKeys(record) {
    return Object.entries(record)
        .filter((x) => {
        return x[1] !== undefined;
    })
        .reduce((filterd, [key, value]) => {
        filterd[key] = value;
        return filterd;
    }, {});
}
const UnionRelationInput = ({ relation, onChange, isDisabled }) => {
    const tag = RelationUtils.getLatestTag(relation);
    const datasetId = tag?.dataset_id;
    const dataset = useSelector((state) => getDataset(state, datasetId));
    const selectedDatasetId = relation.inputs[1]?.tag?.dataset_id;
    const selectedDataset = useSelector((state) => getDataset(state, selectedDatasetId));
    const [fieldMapping, updateFieldMapping] = useState({});
    const [isShowAuto, updateIsShowAuto] = useState(false);
    const account = useSelector((state) => getAccount(state, dataset?.account_id));
    const datasets = useSelector((state) => getDatasetsArr(state));
    const accountLabel = account?.name ?? `Account Id: ${dataset?.account_id}`;
    const validDatasets = datasets.filter((d) => d.id != dataset?.id && d.account_id == dataset?.account_id);
    const leftRelation = relation.inputs[0];
    const rightRelation = relation.inputs[1];
    const leftContext = RelationUtils.getOutputContext(leftRelation);
    const nonAutoFields = [];
    const remainingFields = [];
    const mappedFields = [];
    const availableLeftFieldsSet = new Set(Object.keys(leftContext));
    if (rightRelation !== undefined) {
        const rightContext = RelationUtils.getOutputContext(rightRelation);
        for (const right of Object.keys(rightContext)) {
            if (leftContext[fieldMapping[right]]) {
                nonAutoFields.push(right);
                availableLeftFieldsSet.delete(fieldMapping[right]);
            }
            else if (leftContext[right]) {
                mappedFields.push(right);
                availableLeftFieldsSet.delete(right);
            }
            else {
                remainingFields.push(right);
                nonAutoFields.push(right);
            }
        }
    }
    const availableLeftFields = [...availableLeftFieldsSet.values()];
    const hasMatches = mappedFields.length > 0 || remainingFields.length < nonAutoFields.length;
    return (React.createElement("div", { className: styles.joinBody, style: { fontSize: "12px", minHeight: "0px" } },
        React.createElement("div", { className: styles.jBold }, selectedDataset ? "Selected Dataset" : "Select Dataset (Minimum of 1,000 rows required)"),
        React.createElement(Select, { key: selectedDataset?.id, options: DATASET_MAPPER.mapAll(validDatasets), value: DATASET_MAPPER.map(selectedDataset), onChange: selectOnChangeWrapper((update) => onChange({
                ...relation,
                inputs: update === undefined ? [relation.inputs[0]] : [relation.inputs[0], RelationUtils.fromDataset(update)]
            })), placeholder: `Search or Select a Dataset Stored in ${accountLabel}`, isDisabled: isDisabled, isClearable: true }),
        selectedDataset && selectedDataset.number_of_rows < 1000 && (React.createElement("div", { className: styles.appendWarning },
            React.createElement("span", null,
                React.createElement(FontAwesomeIcon, { icon: faExclamationTriangle, style: { color: "#F8CD7E" } })),
            React.createElement("span", { style: { marginLeft: "5px" } }, "Dataset has too few rows. Minimum 1,000 required."))),
        selectedDataset && nonAutoFields && nonAutoFields.length > 0 && (React.createElement("div", { style: { marginTop: "20px" } }, remainingFields && remainingFields.length > 0 ? (React.createElement("div", null,
            React.createElement("div", { className: styles.jBold }, "Unable to map " + remainingFields.length + " field" + (remainingFields.length > 1 ? "s" : "")))) : (React.createElement("div", null, "All fields mapped")))),
        /* bring this back later */ false && selectedDataset && (React.createElement("div", { style: { marginTop: "20px" } },
            nonAutoFields && nonAutoFields.length > 0 ? (React.createElement("div", null,
                remainingFields && remainingFields.length > 0 ? (React.createElement("div", null,
                    React.createElement("div", { className: styles.jBold }, "Unable to map " + remainingFields.length + " field" + (remainingFields.length > 1 ? "s" : "")),
                    React.createElement("div", null, "Please map the fields in the new dataset to the fields in " +
                        dataset?.name +
                        ". Any fields you do not map will be ignored."))) : (React.createElement("div", null, "All fields mapped")),
                React.createElement("div", { className: styles.jFlex, style: { marginTop: "20px" } },
                    React.createElement("div", { className: styles.jFlexItem, style: { marginRight: "5px" } },
                        React.createElement("div", { className: styles.jBold + " " + styles.jLabel }, "Field in " + selectedDataset?.name)),
                    React.createElement("div", { className: styles.jFlexItem, style: { marginLeft: "5px" } },
                        React.createElement("div", { className: styles.jBold }, "Map To"))),
                nonAutoFields.map((f) => (React.createElement("div", { key: f, className: styles.aFlex },
                    React.createElement("div", { className: styles.jFlexItem, style: { marginRight: "5px" } }, f),
                    React.createElement("div", { className: styles.jFlexItem, style: { marginLeft: "5px" } },
                        React.createElement(Select, { key: f, options: mapToSelectOptions(availableLeftFields), onChange: selectOnChangeWrapper((val) => updateFieldMapping(filterUndefinedKeys({
                                ...fieldMapping,
                                [f]: val
                            }))), value: mapToSelectOption(fieldMapping[f]), isDisabled: isDisabled || selectedDataset === undefined, isClearable: true }))))))) : (React.createElement("div", { className: styles.jBold }, "All fields automatically matched")),
            React.createElement("div", null,
                React.createElement("a", { onClick: () => updateIsShowAuto(!isShowAuto) }, (isShowAuto ? "Hide " : "View ") + mappedFields.length + " Automaticaly Mapped Fields"),
                isShowAuto && (React.createElement("div", null, mappedFields.map((f) => (React.createElement("div", { key: f, className: styles.aFlex },
                    React.createElement("div", { className: styles.jFlexItem, style: { marginRight: "5px" } }, f),
                    React.createElement("div", { className: styles.jFlexItem, style: { marginLeft: "5px" } },
                        React.createElement(Select, { key: f, options: mapToSelectOptions(availableLeftFields), onChange: selectOnChangeWrapper((val) => updateFieldMapping(filterUndefinedKeys({
                                ...fieldMapping,
                                [f]: val
                            }))), value: mapToSelectOption(fieldMapping[f] ?? f), isDisabled: isDisabled || selectedDataset === undefined }))))))))))));
};
export default UnionRelationInput;
